
$(function() {
  let isDrawingEnabled = true;

  let temperatureMain;
  let temperatureGuest;

  const timeZonePreMain = document.querySelector('.time-cdmx[data-time-zone]')?.getAttribute('data-time-zone') || 'mex';
  const timeZonePreGuest = document.querySelector('.time-ny [data-time-zone]')?.getAttribute('data-time-zone') || 'nyc';

  const timezoneData = {
    'tyo': { zone: 'Asia/Tokyo', lat: 35.6895, lon: 139.6917 },
    'nyc': { zone: 'America/New_York', lat: 40.7128, lon: -74.0060 },
    'lon': { zone: 'Europe/London', lat: 51.5074, lon: -0.1278 },
    'par': { zone: 'Europe/Paris', lat: 48.8566, lon: 2.3522 },
    'ber': { zone: 'Europe/Berlin', lat: 52.5200, lon: 13.4050 },
    'syd': { zone: 'Australia/Sydney', lat: -33.8688, lon: 151.2093 },
    'la': { zone: 'America/Los_Angeles', lat: 34.0522, lon: -118.2437 },
    'bcn': { zone: 'Europe/Madrid', lat: 41.3851, lon: 2.1734 },
    'mad': { zone: 'Europe/Madrid', lat: 40.4168, lon: -3.7038 },
    'mty': { zone: 'America/Mexico_City', lat: 25.6866, lon: -100.3161 },
    'gdl': { zone: 'America/Mexico_City', lat: 20.6597, lon: -103.3496 },
    'dxb': { zone: 'Asia/Dubai', lat: 25.2048, lon: 55.2708 },
    'hkg': { zone: 'Asia/Hong_Kong', lat: 22.3193, lon: 114.1694 },
    'sao': { zone: 'America/Sao_Paulo', lat: -23.5505, lon: -46.6333 },
    'sin': { zone: 'Asia/Singapore', lat: 1.3521, lon: 103.8198 },
    'ams': { zone: 'Europe/Amsterdam', lat: 52.3676, lon: 4.9041 },
    'rom': { zone: 'Europe/Rome', lat: 41.9028, lon: 12.4964 },
    'sto': { zone: 'Europe/Stockholm', lat: 59.3293, lon: 18.0686 },
    'mex': { zone: 'America/Mexico_City', lat: 19.4326, lon: -99.1332 },
    'tor': { zone: 'America/Toronto', lat: 43.6532, lon: -79.3832 },
    'chi': { zone: 'America/Chicago', lat: 41.8781, lon: -87.6298 },
    'lis': { zone: 'Europe/Lisbon', lat: 38.7223, lon: -9.1393 },
    'bru': { zone: 'Europe/Brussels', lat: 50.8503, lon: 4.3517 },
    'vie': { zone: 'Europe/Vienna', lat: 48.2082, lon: 16.3738 },
    'ath': { zone: 'Europe/Athens', lat: 37.9838, lon: 23.7275 },
    'ist': { zone: 'Europe/Istanbul', lat: 41.0082, lon: 28.9784 },
    'cai': { zone: 'Africa/Cairo', lat: 30.0444, lon: 31.2357 },
    'jnb': { zone: 'Africa/Johannesburg', lat: -26.2041, lon: 28.0473 },
    'mow': { zone: 'Europe/Moscow', lat: 55.7558, lon: 37.6173 },
    'del': { zone: 'Asia/Kolkata', lat: 28.6139, lon: 77.2090 },
    'bkk': { zone: 'Asia/Bangkok', lat: 13.7563, lon: 100.5018 },
    'sel': { zone: 'Asia/Seoul', lat: 37.5665, lon: 126.9780 },
    'akl': { zone: 'Pacific/Auckland', lat: -36.8485, lon: 174.7633 },
    'hnl': { zone: 'Pacific/Honolulu', lat: 21.3069, lon: -157.8583 },
    'anc': { zone: 'America/Anchorage', lat: 61.2181, lon: -149.9003 },
    'den': { zone: 'America/Denver', lat: 39.7392, lon: -104.9903 },
    'scl': { zone: 'America/Santiago', lat: -33.4489, lon: -70.6693 },
    'eir': { zone: 'Atlantic/Cape_Verde', lat: 14.9177, lon: -23.5092 },
    'tbs': { zone: 'Asia/Tbilisi', lat: 41.7151, lon: 44.8271 },
    'khi': { zone: 'Asia/Karachi', lat: 24.8607, lon: 67.0011 },
    'dac': { zone: 'Asia/Dhaka', lat: 23.8103, lon: 90.4125 },
    'nou': { zone: 'Pacific/Noumea', lat: -22.2735, lon: 166.4463 },
    'ppg': { zone: 'Pacific/Pago_Pago', lat: -14.2710, lon: -170.7020 }
  };

  function getCityData(key) {
    return timezoneData[key] || { zone: 'UTC', lat: 0.0, lon: 0.0 };
  }

  function getCityAbbreviation(timezoneName, cityName) {
    if (!timezoneName) timezoneName = '';
    
    let tzCity = timezoneName.split('/').pop().replace(/_/g, ' ').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    let cityNorm = cityName ? cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';
    
    let isPrimaryTzCity = (!cityName) || (cityNorm === tzCity);

    if (isPrimaryTzCity) {
      if (timezoneName === 'America/Mexico_City') return 'CDMX';
      if (timezoneName === 'Europe/Madrid') return 'MAD';
      
      for (const [key, data] of Object.entries(timezoneData)) {
        if (data.zone === timezoneName) return key.toUpperCase();
      }
    }
    
    let targetName = cityName || tzCity;
    if (targetName) {
      if (targetName.length <= 4) return targetName.toUpperCase();
      
      const words = targetName.split(' ');
      if (words.length > 1) {
        let abbr = '';
        for (let i = 0; i < words.length && i < 3; i++) {
          if (words[i].length > 0) abbr += words[i][0].toUpperCase();
        }
        return abbr;
      }
      return targetName.substring(0, 3).toUpperCase();
    }
    
    return '';
  }

  const mainCityData = getCityData(timeZonePreMain);
  const guestCityData = getCityData(timeZonePreGuest);

  const timeZoneMain = mainCityData.zone;
  const latMain = mainCityData.lat;
  const lonMain = mainCityData.lon;

  const timeZoneGuest = guestCityData.zone;
  const latGuest = guestCityData.lat;
  const lonGuest = guestCityData.lon;

  function syncTemperaturesIfMatching() {
    let mainLabel = $('.time-main-label').text().trim().toLowerCase();
    let localLabel = $('.time-local-label').text().trim().toLowerCase();
    
    if (mainLabel && mainLabel === localLabel && temperatureMain !== undefined) {
       $('.temperature-local').text(temperatureMain + ' °C');
    }
  }

  fetch(`https://api.open-meteo.com/v1/forecast?latitude=${latMain}&longitude=${lonMain}&current_weather=true`)
  .then(res => res.json())
  .then(data => {
    temperatureMain = Math.floor(data.current_weather.temperature);
    $('.temperature-cdmx').text(temperatureMain + ' °C');
    syncTemperaturesIfMatching();
  });

  let activeLocalTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  fetch('https://get.geojs.io/v1/ip/geo.json')
    .then(res => res.json())
    .then(location => {
      if (location.timezone) {
        activeLocalTimeZone = location.timezone;
      }
      let locationName = location.city;
      if (location.country_code === 'US' || location.country_code === 'MX') {
        if (location.region) {
          locationName = location.region;
        }
      }
      if (locationName) {
        $('.time-local-label').text(getCityAbbreviation(location.timezone, locationName));
      }
      return fetch(`https://api.open-meteo.com/v1/forecast?latitude=${location.latitude}&longitude=${location.longitude}&current_weather=true`);
    })
    .then(res => res.json())
    .then(data => {
      temperatureGuest = Math.floor(data.current_weather.temperature);
      $('.temperature-local').text(temperatureGuest + ' °C').show();
      syncTemperaturesIfMatching();
    })
    .catch(err => console.log('Could not fetch local weather', err));
 

  function calculateAndLogOffsets() {
      $('.in-reference').each(function(index, element) {
          var offset = $(element).offset().top;
          var outElementSelector = $(element).data('out-element');
          $(outElementSelector).css('paddingTop', offset + 'px');
      });
  }

    function debounce(func, wait) {
        var timeout;
        return function() {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };
    } 

    setTimeout(function() { 
      calculateAndLogOffsets();
    }, 800);

    calculateAndLogOffsets();
    $(window).resize(debounce(calculateAndLogOffsets, 200));


    $('.cont-news .close-svg').on('click', function() {
        $('.news').addClass('d-none');
    });

   

    
    const cursor = $('.cursor');
    initBasicCustomCursor();

    let interval;

    $('.img-swiper-container').on('mouseenter', function() {
        cursor.text(''); 
        const price = $(this).data('price').toString();
        cursor.addClass('cursor--hover');
        let index = 0;
        let currentText = ''; // Variable to store the text being built

        clearInterval(interval); 
        
        interval = setInterval(() => {
            if (index < price.length) {
                currentText += price[index]; // Append the next character to currentText
                cursor.text(currentText);   // Set the cursor text to currentText
                index++;
            } else {
                clearInterval(interval);
            }
        }, 35);
    });
    
    $('.img-swiper-container').on('mouseleave', function() {
        cursor.removeClass('cursor--hover').text('');
        clearInterval(interval);
    });

    
    let fallbackCityStr = activeLocalTimeZone.split('/').pop().replace(/_/g, ' ');
    let fallbackCity = getCityAbbreviation(activeLocalTimeZone, fallbackCityStr);
    if (!$('.time-local-label').text().trim() || $('.time-local-label').text().trim() === 'LOCAL TIME' || $('.time-local-label').text().trim() === 'Local Time') {
      $('.time-local-label').text(fallbackCity);
    }
    
    hour1 = $('.time-local .hour');
    minutes1 = $('.time-local .minutes');
    seconds1 = $('.time-local .seconds');

    setInterval(function() {
      updateTime(hour1, minutes1, seconds1, activeLocalTimeZone);
    }, 1000);

    hour2 = $('.time-cdmx .hour');
    minutes2 = $('.time-cdmx .minutes');
    seconds2 = $('.time-cdmx .seconds');

    setInterval(function() {
      updateTime(hour2, minutes2, seconds2, timeZoneMain);
    }, 1000);
    
    var square = document.getElementById("drawPlace");

    function fitToContainer(canvas){
      // Make it visually fill the positioned parent
      canvas.style.width ='100%';
      canvas.style.height='100%';
      // ...then set the internal size to match
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }

    fitToContainer(square);
    
    const externalInputEmailInit = document.querySelector('input#external-input-email');
    const savedEmailInit = sessionStorage.getItem('zamme_drawing_email');
    if (externalInputEmailInit && savedEmailInit) {
        externalInputEmailInit.value = savedEmailInit;
        sessionStorage.removeItem('zamme_drawing_email');
        setTimeout(() => {
            if ($('.tap-draw').is(':visible')) {
                $('.tap-draw').trigger('click');
            }
        }, 100);
    }
    
    var paper = square.getContext("2d");
    var pressedMouse = false; 
    var x;
    var y;
    var colorLine ="#000000";
    var key = {C: 100};

    var strokes = [];        // All completed strokes (normalized 0-1 coords)
    var currentStroke = [];  // Current active stroke points (normalized)
    window._zammeStrokes = strokes; // Expose for restart handler

    square.addEventListener("mousedown", startDrawing);
    square.addEventListener("mousemove", drawLine);
    square.addEventListener("touchstart", startDrawingTouch, { passive: false });
    square.addEventListener("touchmove", drawLineTouch, { passive: false });
    document.addEventListener("mouseup", stopDrawing);
    square.addEventListener("touchend", stopDrawing);
    document.addEventListener("keydown", clearCanvas);

    function startDrawing(eventvs01){
        pressedMouse = true;
        x = eventvs01.offsetX;
        y = eventvs01.offsetY;
        currentStroke = [{ nx: x / square.width, ny: y / square.height }];
    }

    let points = [];
    let lastSmoothedWidth = 10;

    function drawLine(event) {
      if (!isDrawingEnabled) return;
      if (!pressedMouse ) return;

      if ($('#export-button').hasClass('empty')) {
        $('#export-button').removeClass('empty');
      }
      hasDrawn = true;
  
      const xM = event.offsetX;
      const yM = event.offsetY;

      if (points.length > 0) {
          const lastPoint = points[points.length - 1];
          const dx = xM - lastPoint.x;
          const dy = yM - lastPoint.y;
          if (dx * dx + dy * dy < 16) return; // Avoid processing points too close to each other (4px)
      }

      points.push({ x: xM, y: yM });
      currentStroke.push({ nx: xM / square.width, ny: yM / square.height });
  
      drawSmoothLine();
    }

    function drawSmoothLine() {
      if (points.length < 3) return;
  
      const prev = points[points.length - 3];
      const current = points[points.length - 2];
      const next = points[points.length - 1];
  
      const xc = (current.x + next.x) / 2;
      const yc = (current.y + next.y) / 2;

      let startX = points.length === 3 ? prev.x : (prev.x + current.x) / 2;
      let startY = points.length === 3 ? prev.y : (prev.y + current.y) / 2;
  
      paper.beginPath();
      const targetWidth = calculateLineWidth(current, next);
      let smoothedWidth = points.length === 3 ? targetWidth : lastSmoothedWidth + (targetWidth - lastSmoothedWidth) * 0.3;
      lastSmoothedWidth = smoothedWidth;
      
      paper.lineWidth = smoothedWidth;
      paper.lineJoin = "round";
      paper.lineCap = "round";
      paper.strokeStyle = colorLine;
  
      paper.moveTo(startX, startY);
      paper.quadraticCurveTo(current.x, current.y, xc, yc);
      paper.stroke();
      paper.closePath();
    }

    function calculateLineWidth(p1, p2) {
      const dx = p2.x - p1.x;
      const dy = p2.y - p1.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      
      const maxLineWidth = 15;
      const minLineWidth = 5;
  
      // Faster movements decrease line width naturally
      const lineWidth = maxLineWidth - (dist / 40) * (maxLineWidth - minLineWidth);
      return Math.max(minLineWidth, Math.min(maxLineWidth, lineWidth));
  }
  
    function stopDrawing() {
        pressedMouse = false;
        points = [];
        if (currentStroke.length > 0) {
            strokes.push(currentStroke.slice());
            currentStroke = [];
        }
    }

    function clearCanvas(whenPressKey) {
        if (whenPressKey.keyCode == key.C) {
            paper.clearRect(0, 0, square.width, square.height);
            strokes.length = 0;
            window._zammeStrokes = strokes;
            currentStroke = [];
        }
    }
    drawing_line("#000000", x-1, y, x, y, paper);

    function drawing_line(color, x_start, y_start, x_end, y_end, board){
        board.beginPath();
        board.strokeStyle = color;
        board.lineWidth = 2;
        board.moveTo(x_start,y_start);
        board.lineTo(x_end,y_end);
        board.stroke(); 
        board.closePath();
    }

    document.getElementById('export-button').addEventListener('click', function (e) {
      e.preventDefault();

      const drawingFormContainer = document.querySelector(".drawing-form");
      let formEmbed = Array.from(drawingFormContainer?.querySelectorAll("*") || []).find(el => el.shadowRoot);

      if (!formEmbed || !formEmbed.shadowRoot) {
        console.error("Form embed or Shadow DOM not found.");
        return;
      }
      

      let inputEmail = formEmbed.shadowRoot.querySelector('input#email');

      if (!inputEmail) {
         alert("You have already submitted a drawing! Please click 'Restart' to submit another one.");
         return;
      }
      let externalInputEmail = document.querySelector('input#external-input-email');
      let valueEmail = externalInputEmail.value;
      let formInside = formEmbed.shadowRoot.querySelector('form');

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(valueEmail)) {
        $('.text-error-email').addClass('submitted'); // Add error class if {{ 'general.validation.email' | t }}
        return; // Stop further execution
      }

      // Set the value of the inputEmail field
      inputEmail.value = valueEmail;

      // Trigger an input event to notify the form validation system
      inputEmail.dispatchEvent(new Event('input', { bubbles: true }));

      // Handle the drawing canvas
      var square = document.getElementById("drawPlace");
      var dataURL = square.toDataURL('image/png');
      let file = base64ToFile(dataURL, "image.png");

      let inputDraw = formEmbed.shadowRoot.querySelector('input[type="file"]');

      let dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      inputDraw.files = dataTransfer.files;

      console.log("Updated input field files:", inputDraw.files);

      let event = new Event("change", { bubbles: true });
      inputDraw.dispatchEvent(event);

      formInside.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      $('.text-success-draw').addClass('submitted');
      $('.footer-canva').addClass('submitted');
      $('.text-error-email').removeClass('submitted'); 

      isDrawingEnabled = false;
      $('#export-button').addClass('empty');
      window._hasSubmittedDrawing = true;

    });



    function startDrawingTouch(e) {
      if (!isDrawingEnabled || !touchDrawingActivated) return;
      if (e.cancelable) e.preventDefault();
      pressedMouse = true;
      const touch = e.touches[0];
      const rect = square.getBoundingClientRect();
      x = touch.clientX - rect.left;
      y = touch.clientY - rect.top;
      points.push({ x, y });
      currentStroke = [{ nx: x / square.width, ny: y / square.height }];
  }
  
    function drawLineTouch(e) {
        if (!pressedMouse) return;
        if (!isDrawingEnabled || !touchDrawingActivated) return;

        if ($('#export-button').hasClass('empty')) {
            $('#export-button').removeClass('empty');
        }

        if (e.cancelable) e.preventDefault();
    
        const touch = e.touches[0];
        const rect = square.getBoundingClientRect();
        const xM = touch.clientX - rect.left;
        const yM = touch.clientY - rect.top;

        if (points.length > 0) {
            const lastPoint = points[points.length - 1];
            const dx = xM - lastPoint.x;
            const dy = yM - lastPoint.y;
            if (dx * dx + dy * dy < 25) return; // Larger deadzone (5px) for touch jitters
        }
    
        points.push({ x: xM, y: yM });
        currentStroke.push({ nx: xM / square.width, ny: yM / square.height });
    
        drawSmoothLine();
    }
    

    function base64ToFile(base64, filename) {
        let arr = base64.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], filename, { type: mime });
    }

    $('.tap-draw').on('click', function() {
        touchDrawingActivated = true;
        $(this).fadeOut(300, function() {
            $(this).addClass('d-none');
            $('.close-draw').removeClass('d-none').fadeIn(300);
        });
    });

    $('.close-draw').on('click', function() {
        touchDrawingActivated = false;
        $(this).fadeOut(300, function() {
            $(this).addClass('d-none');
            $('.tap-draw').removeClass('d-none').fadeIn(300);
        });
    });

    // --- Redraw all saved strokes from normalized coordinates ---
    function redrawAllStrokes() {
        var w = square.width;
        var h = square.height;
        paper.clearRect(0, 0, w, h);

        for (var s = 0; s < strokes.length; s++) {
            var pts = strokes[s];
            if (pts.length < 3) continue;

            for (var i = 2; i < pts.length; i++) {
                var prev    = { x: pts[i - 2].nx * w, y: pts[i - 2].ny * h };
                var current = { x: pts[i - 1].nx * w, y: pts[i - 1].ny * h };
                var next    = { x: pts[i].nx * w,     y: pts[i].ny * h };

                var xc = (current.x + next.x) / 2;
                var yc = (current.y + next.y) / 2;

                var startX = (i === 2) ? prev.x : (prev.x + current.x) / 2;
                var startY = (i === 2) ? prev.y : (prev.y + current.y) / 2;

                paper.beginPath();
                var targetWidth = calculateLineWidth(current, next);
                var smoothedWidth = (i === 2) ? targetWidth : lastSmoothedWidth + (targetWidth - lastSmoothedWidth) * 0.3;
                lastSmoothedWidth = smoothedWidth;

                paper.lineWidth = smoothedWidth;
                paper.lineJoin = "round";
                paper.lineCap = "round";
                paper.strokeStyle = colorLine;
                paper.moveTo(startX, startY);
                paper.quadraticCurveTo(current.x, current.y, xc, yc);
                paper.stroke();
                paper.closePath();
            }
        }
    }

    // --- Resize handler: re-fit canvas + redraw ---
    $(window).resize(debounce(function() {
        fitToContainer(square);
        redrawAllStrokes();
    }, 200));

    $(document).on('click', '#restart-draw', function(e) {
        if (window._hasSubmittedDrawing) {
            let externalInputEmail = document.querySelector('input#external-input-email');
            if (externalInputEmail) {
                sessionStorage.setItem('zamme_drawing_email', externalInputEmail.value);
            }
            window.location.hash = 'footer';
            window.location.reload();
            return;
        }
        if (!$('#export-button').hasClass('empty')) {
          $('#export-button').addClass('empty');
        }
        const square = document.getElementById("drawPlace");
        const paper = square.getContext("2d");
        paper.clearRect(0, 0, square.width, square.height);
        
        // Clear stored strokes so they don't reappear on resize
        if (window._zammeStrokes) window._zammeStrokes.length = 0;
        
        // Reset state and UI elements
        isDrawingEnabled = true;
        $('.text-success-draw').removeClass('submitted');
        $('.footer-canva').removeClass('submitted');
        $('.text-error-email').removeClass('submitted');
    });

});


function updateTime($hour, $minutes, $seconds, timeZone) {
  const currentDate = new Date(new Date().toLocaleString("en-US", { timeZone }));
  let currentHour = currentDate.getHours().toString().padStart(2, '0');
  let currentMinutes = currentDate.getMinutes().toString().padStart(2, '0');
  let currentSeconds = currentDate.getSeconds().toString().padStart(2, '0');

  $hour.text(currentHour);
  $minutes.text(currentMinutes);
  $seconds.text(currentSeconds);
}


function resetDraw() {
  const canvas = document.getElementById('drawingCanvas'); 
  if (canvas) {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height); 
    console.log('Canvas cleared.');
  } else {
    console.warn('Canvas not found.');
  }
}


function initBasicCustomCursor() {
    const cursor = document.querySelector('.cursor');
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let currentX = mouseX;
    let currentY = mouseY;
    let animation = null;
  
    window.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
  
      // Mostrar cursor si estaba oculto (con !important)
      cursor.style.setProperty('display', 'block', 'important');
  
      if (animation) {
        animation.cancel();
      }
  
      animation = cursor.animate(
        [
          { transform: `translate3d(${currentX}px, ${currentY}px, 0)` },
          { transform: `translate3d(${mouseX}px, ${mouseY}px, 0)` }
        ],
        {
          duration: 400,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'forwards'
        }
      );
  
      currentX = mouseX;
      currentY = mouseY;
    });
  
    // Mouse sale de la ventana
    window.addEventListener('mouseleave', () => {
      cursor.style.setProperty('display', 'none', 'important');
    });
  
    // Mouse entra de nuevo
    window.addEventListener('mouseenter', () => {
      cursor.style.setProperty('display', 'block', 'important');
    });
  }




function base64ToFile(base64, filename) {
    let arr = base64.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, { type: mime });
}